import React from 'react';
import styled from 'styled-components';
import Select from 'react-select';

import { searchOptions } from 'utils/constants';
import { useSearch } from 'utils/hooks';
import { Button } from 'components/common';

export const customStyles = {
  option: (provided) => ({
    ...provided,
    padding: 20,
  }),
  container: (provided) => ({
    ...provided,
    minWidth: '196px',
    marginLeft: '14px',
    marginRight: '4px',
  }),

  control: (provided) => ({
    ...provided,
    paddingLeft: '12px',
    minHeight: '3rem',
  }),
  input: () => ({
    display: 'none',
  }),
  singleValue: () => ({}),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  indicatorsContainer: () => ({
    marginRight: '12px',
    svg: {},
  }),
};
const GenericTopSection = ({ title, placeholder, children }) => {
  const {
    input,
    term,
    error,
    type,
    trigger,
    clear,
    clearError,
    setTerm,
    validate,
    setInput,
    setType,
  } = useSearch();
  return (
    <Wrapper>
      <h3>{title}</h3>
      {children}
      <InputSection>
        <img
          src="/icons/search.svg"
          alt="search"
          className="search-icon"
          height="16"
          width="16"
        />
        <input
          type="text"
          onChange={(e) => {
            validate(e.target.value);
            setInput(e.target.value);
            if (!e.target.value && term) setTerm('');
          }}
          placeholder={placeholder}
          value={input}
          className={error !== '' ? 'input-error' : ''}
        />
        {error !== '' && <span className="error">{error}</span>}
        {input !== '' && <Clear onClick={clear}>Clear</Clear>}
      </InputSection>
      <Select
        classNamePrefix="search-select"
        isSearchable={false}
        instanceId="search-select"
        value={searchOptions.find((o) => o.value === type)}
        options={searchOptions}
        styles={customStyles}
        onChange={(selected) => {
          setType(selected.value);
          clearError();
        }}
      />
      <SearchBtn onClick={trigger} disabled={error !== ''}>
        Search
      </SearchBtn>
    </Wrapper>
  );
};

export default GenericTopSection;

const Wrapper = styled.div`
  display: flex;
  /* border: 1px solid green; */
  justify-content: space-between;
  width: 100%;
  align-items: center;
  h3 {
    margin: 0;
    white-space: nowrap;
  }
  .search-select__single-value {
    white-space: nowrap;
  }
`;

export const InputSection = styled.div`
  margin-left: auto;
  position: relative;
  img {
    position: absolute;
    top: calc(50% - 8px);
    left: 16px;
  }
  input {
    outline: none;
    font-family: Overpass;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 25px;
    padding: 10px 66px 10px 40px;
    border: 1px solid #c5c5c5;
    box-sizing: border-box;
    border-radius: 4px;
    &.input-error {
      border-color: red;
    }
  }
  span.error {
    position: absolute;
    bottom: -22px;
    left: 0;
    color: red;
    font-weight: 500;
    font-size: 12px;
    line-height: 150%;
  }
`;

export const SearchBtn = styled(Button)`
  &:disabled {
    opacity: 0.5;
  }
  margin-left: 12px;
  outline: none;
  border: none;
  padding: 13px 24px;
  border-radius: 4px;
  background-color: #3f76e6;
  font-family: 'Overpass';
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  color: #ffffff;
`;

export const Clear = styled.button`
  outline: none;
  position: absolute;
  top: calc(50% - 15px);
  right: 8px;
  padding: 4px 9px;
  margin-left: 12px;
  background-color: tomato;
  border: none;
  color: white;
  display: flex;
  border-radius: 4px;
  align-items: center;
  font-size: 12px;
  line-height: 14px;
  font-weight: 700;
  font-family: 'Overpass', sans-serif;
  &:before {
    margin-top: 2px;
    content: url('/icons/clear-icon.svg');
    margin-right: 4px;
  }
`;
